import { QuoteReservation } from '@/models/quote'
import { getBoughtServicesTotal } from '@/utils/timeSchedules'

export function sumCartTicketQuantity({
  cartReservations,
  serviceIds,
}: {
  cartReservations: QuoteReservation[]
  serviceIds: Set<number>
}): number {
  return cartReservations.reduce((total, reservation) => {
    const reservationTotal = Object.entries(reservation.boughtServices).reduce(
      (carry, [key, boughtService]) => {
        const serviceId = Number(key)

        if (serviceIds.has(serviceId)) {
          return carry + getBoughtServicesTotal(boughtService)
        }

        return carry
      },
      0
    )

    return total + reservationTotal
  }, 0)
}

export function sumCartGroupTicketQuantity({
  cartReservations,
  groupServiceIds,
}: {
  cartReservations: QuoteReservation[]
  groupServiceIds: number[]
}): number {
  return sumCartTicketQuantity({
    cartReservations,
    serviceIds: new Set(groupServiceIds),
  })
}
